// extracted by mini-css-extract-plugin
export default {"dialog":"RemoveDialog_dialog__Ll5cR"};